import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { validateEmail } from '../../utils/emailRegex';
import { CoreService } from 'src/modules/core/services';
import { UserService } from '../../services';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { CommonServices, SharedValidators, AppFilter } from 'src/modules/shared';
@Component({
	selector: 'app-rest-password',
	templateUrl: './reset-password.component.html',
	styleUrls: [ './reset-password.component.scss' ]
})
export class ResetPasswordComponent {
	resetForm: FormGroup;
	resetFormSuccess: boolean;
	resetFormError: boolean;

	formSubmitAttempt: boolean;

	relaxed: boolean;

	//global pendng
	pending: boolean;
	success: boolean;
	error: any;

	token: any;

	private unsubscribe$: Subject<void> = new Subject<void>();
	constructor(private fb: FormBuilder, private userService: UserService, private route: ActivatedRoute) {
		this.route.queryParams.subscribe((params) => {
			const token = params['token'];
			this.token = token;
		});

		this.resetForm = this.fb.group(
			{
				password: [ '', [ Validators.required, SharedValidators.strongPassword ] ],
				confirmPassword: [ '', [ Validators.required, SharedValidators.strongPassword ] ],
				captcha: [ '', [ Validators.required ] ]
			},
			{ validator: SharedValidators.matchingPasswords('password', 'confirmPassword') }
		);
	}

	isFieldValid(field: string) {
		return (
			(!this.resetForm.get(field).valid && this.resetForm.get(field).touched) ||
			(this.resetForm.get(field).untouched && this.formSubmitAttempt)
		);
	}

	displayFieldCss(field: string) {
		return {
			error: this.isFieldValid(field)
		};
	}

	submitChange() {
		this.resetFormSuccess = false;
		this.resetFormError = false;
		if (this.resetForm.valid) {
			this.pending = true;
			let realbody = this.resetForm.value;
			realbody['token'] = this.token;
			this.userService.resetPassword({ body: realbody }).pipe(takeUntil(this.unsubscribe$)).subscribe(
				(res) => {
					this.pending = false;
					this.resetFormSuccess = true;
					console.log('in success', res);
					// if (res["validationStatus"]) {
					//   this.resetFormSuccess = true;
					// }
				},
				(error) => {
					console.log('in error', error);
					this.pending = false;
					this.resetFormError = true;
				}
			);
		} else {
			this.formSubmitAttempt = true;
		}
	}
}
